<template>

  <div class="col-span-6 sm:col-span-4">

    <div class="flex items-center justify-between">
      <label for="placeholder_question"
        class="block text-sm font-medium leading-5 text-gray-700">Platzhalter-Frage</label>


      <svg
      v-if="! containsPlaceholder"
       @click="insertPlaceholder" v-tooltip.top="`%BRANDNAME in Frage einfügen`" xmlns="http://www.w3.org/2000/svg"
        fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-5 h-5 text-gray-900 hover:text-markencode-blue cursor-pointer outline-none">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
      </svg>

      <svg
      v-else
       v-tooltip.top="`Die Frage enthält bereits %BRANDNAME`" xmlns="http://www.w3.org/2000/svg"
        fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-5 h-5 text-gray-400 outline-none">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
      </svg>
    </div>


    <textarea id="placeholder_question" ref="placeholder_question" v-model="placeholder_question"
      @click="setCursorPosition" @input="setCursorPosition" :disabled="processing" rows="3"
      class="shadow-sm focus:ring-gray-400 focus:border-gray-400 mt-1 block w-full sm:text-sm border-gray-300 rounded-md"></textarea>
    <p v-if="numContainedPlaceholders > 1" class="text-xs mt-2 text-markencode-red">Bitte nutzen Sie den Platzhalter %BRANDNAME nur einmal.</p>
    <p class="text-xs mt-2">Bitte nutzen Sie <span class="font-semibold">%BRANDNAME</span>, um den
      Markennamen in die Frage einzubetten.</p>
    <p class="text-xs">Beispiel: "Beschreiben Sie <span class="font-semibold">%BRANDNAME</span> in
      einem Satz."</p>
    <p class="text-xs">Die Frage darf <span class="font-semibold">%BRANDNAME</span> nur <span class="font-semibold">einmal</span> enthalten.</p>
  </div>

</template>

<script>
import HorizontalDivider from '@/Shared/HorizontalDivider';

export default {
  components: {
    HorizontalDivider,
  },

  props: {
    question: Object,
    processing: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      cursorPosition: 0,
      placeholder_question: this.question?.placeholder_question || '',
    };
  },

  watch: {
    placeholder_question: {
      handler: function () {
        this.$emit('questionChanged', this.placeholder_question);
      },
    },
  },

  methods: {
    setCursorPosition() {
      const textarea = this.$refs.placeholder_question;
      this.cursorPosition = textarea.selectionStart;
    },

    insertPlaceholder() {
      if (this.containsPlaceholder) {
        return false;
      }

      const textarea = this.$refs.placeholder_question;
      const textBefore = this.placeholder_question.substring(0, this.cursorPosition);
      const textAfter = this.placeholder_question.substring(this.cursorPosition);

      this.placeholder_question = textBefore + '%BRANDNAME' + textAfter;

      // Set the cursor position after the inserted text
      this.$nextTick(() => {
        const newPosition = this.cursorPosition + '%BRANDNAME'.length;
        textarea.setSelectionRange(newPosition, newPosition);
        textarea.focus();
      });
    },
  },

  computed: {
    containsPlaceholder() {
      return this.placeholder_question.indexOf('%BRANDNAME') != -1;
    },

    numContainedPlaceholders() {
      return (this.placeholder_question.match(/%BRANDNAME/g) || []).length;
    },
  },

};
</script>
